
import React from 'react';
import './film-roll.scss';
const FilmRoll =() => <div id="animatedBackground"></div>
export default FilmRoll;